import React, { useRef, useState, useEffect } from "react";
import Slider from "react-slick";

import {
  Grid,
  Card,
  CardMedia,
  Typography,
  Button,
  Box,
  Divider,
  IconButton,
  CircularProgress,
  Container,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions, Skeleton
} from "@mui/material";
import ArrowBackIosNewIcon from "@mui/icons-material/ArrowBackIosNew";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
import PlayArrowIcon from "@mui/icons-material/PlayArrow";
import PauseIcon from "@mui/icons-material/Pause";
import CurrencyRupeeIcon from "@mui/icons-material/CurrencyRupee";
import ApartmentIcon from "@mui/icons-material/Apartment";
import OpenWithIcon from "@mui/icons-material/OpenWith";
import { useNavigate, useParams } from "react-router-dom";
import { get_plot_detailsview, residential_enquiry, get_settings } from "../../api/ControllApi";
import BreadcrumbsNav from "../../components/common/BreadCrumbNav";
import PlotsLocation from "../Plot_marketPlace/plot_location";
import ResidentialLocation from "./ResidentialLocation";
import theme from "../../utils/theme";
import ShareIcon from "@mui/icons-material/Share";
import HomeIcon from '@mui/icons-material/Home';
import StorefrontIcon from '@mui/icons-material/Storefront';
import ResidentialDescription from "./ResidentialDescription";
import { toast } from "react-toastify";
import { useUser } from "../../context/LoginDetail";
import CallIcon from "@mui/icons-material/Call";
import ResidentialEnquiryDialog from "./ResidentialEnquirDialouge";
import { useModal } from "../../context/ModalContext";
import ResdentialImageView from "./ResidentialImageView";
import ImageViewerCard from "../GIOO_Plots/GiooimageViwerCard";
import ResidentialDocument from "./ResidentialDocument";
import CloseIcon from '@mui/icons-material/Close';
import YouTubeIcon from "@mui/icons-material/YouTube";
import WhatsAppIcon from "@mui/icons-material/WhatsApp";
import PlotDocumentSection from "../Plot_marketPlace/document_section";
import { useCachedApi } from "../../hooks/useCachedApi";
import LocationOnIcon from "@mui/icons-material/LocationOn";
import PlotMap from "../Plot_marketPlace/PlotMap";

/* CUSTOM ARROWS FOR SLIDER */
function NextArrow({ onClick }) {
  return (
    <Box
      onClick={onClick}
      sx={{
        position: "absolute",
        right: { xs: "-10px", md: "-25px" },
        top: "50%",
        transform: "translateY(-50%)",
        cursor: "pointer",
        zIndex: 5,
        bgcolor: "#fff",
        borderRadius: "50%",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        boxShadow: "0 2px 8px rgba(0,0,0,0.15)",
        p: 0.5
      }}
    >
      <img src="/assets/images/right_arrow.png" alt="next" width={30} />
    </Box>
  );
}

function PrevArrow({ onClick }) {
  return (
    <Box
      onClick={onClick}
      sx={{
        position: "absolute",
        left: { xs: "-10px", md: "-25px" },
        top: "50%",
        transform: "translateY(-50%)",
        cursor: "pointer",
        zIndex: 5,
        bgcolor: "#fff",
        borderRadius: "50%",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        boxShadow: "0 2px 8px rgba(0,0,0,0.15)",
        p: 0.5
      }}
    >
      <img src="/assets/images/left_arrow.png" alt="prev" width={30} />
    </Box>
  );
}

// residential_enquiry
export default function ResidentialPlotsDetail() {
  const { requestApi } = useCachedApi();
  const { id } = useParams();
  const navigate = useNavigate();
  const sliderRef = useRef();
  const [data, setData] = useState({});
  const [loading, setLoading] = useState(false);
  const [enquiredloading, setEnquiredLoading] = useState(false);
  const [showAllSpecs, setShowAllSpecs] = useState(false);
  const [open, setOpen] = useState(false);
  const [enquired, setEnquired] = useState(false);
  const { requireLogin } = useModal();
  const [confirmOpen, setConfirmOpen] = useState(false);
  const [documents, setDocuments] = useState([]);
  const [isPlayingMap, setIsPlayingMap] = useState({});
  const [hoveredVideo, setHoveredVideo] = useState(null);
  const videoRefs = useRef({});
  const previewVideoRefs = useRef({});
  const [settings, setSettings] = useState(null);

  // Slider settings
  const sliderSettings = {
    dots: true,
    infinite: false, // Disable infinite to fix video ref/cloning issues
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
  };
  const handleShare = () => {
    const shareUrl = window.location.href;

    if (navigator.share) {
      navigator.share({
        title: data?.property_name || "Property",
        text: "Check out this property",
        url: shareUrl,
      });
    } else {
      navigator.clipboard.writeText(shareUrl);
      alert("Link copied to clipboard");
    }
  };

  const facilities = data.facilities || [];
  const amenitiesall = data.amenitiesall || [];
  const cate = data.cate || [];
  const validFacilities = (facilities || []).filter((f) => {
    const value = String(f?.value || "").trim();
    return value !== "" && value !== "N/A";
  });


  const formatPrice = (num) => {

    if (!num) return "-";
    num = Number(num);

    if (num >= 10000000) return (num / 10000000).toFixed(2) + " Cr";
    if (num >= 100000) return (num / 100000).toFixed(2) + " Lakhs";
    if (num >= 1000) return (num / 1000).toFixed(2) + " K";

    return num.toString();


  };
  const getPropertyDetails = (id) => {
    setLoading(true);
    const cacheKey = `plot_details_${id}`;
    requestApi(cacheKey, () => get_plot_detailsview(id))
      .then((res) => {
        setData(res?.data || {});
      })
      .finally(() => setLoading(false));
  };

  const fetchSettings = async () => {
    try {
      const res = await get_settings();
      if (res && res.data) {
        setSettings(res.data);
      }
    } catch (err) {
      console.error("Error fetching settings:", err);
    }
  };

  useEffect(() => {
    getPropertyDetails(id);
    fetchSettings();
  }, [id]);

  const lat = data?.lat;
  const lng = data?.lng;
  const isValidLocation =
    lat !== null &&
    lng !== null &&
    lat !== "" &&
    lng !== "" &&
    !isNaN(lat) &&
    !isNaN(lng);

  // Images for slider
  const images = data.gallery_images?.length
    ? data.gallery_images
    : [data.thumbnail];
  const whatsappNumber = settings?.whatsapp;
  // document


  // slider
  const showArrows = images.length > 1;

  // slider image preview 
  const showPreviewArrows = images.length > 1;
  const [previewOpen, setPreviewOpen] = useState(false);
  const [activeIndex, setActiveIndex] = useState(0);
  const previewSliderRef = useRef();
  const handleImagePreview = (index) => {
    setActiveIndex(index);
    setPreviewOpen(true);

    setTimeout(() => {
      previewSliderRef.current?.slickGoTo(index);
    }, 100);
  };
  // Compute per sqft price
  const perSqft = data.price && data.area_sqft
    ? (parseFloat(data.price) * 100000 / parseFloat(data.area_sqft)).toFixed(2)
    : "-";

  const handleResidentialQuery = async () => {
    if (enquired) {
      toast.info("You have already sent an enquiry!");
      return;
    }
    const formData = {
      property_id: id
    };

    setEnquiredLoading(true);

    try {
      const res = await residential_enquiry(formData);

      if (res?.status === true) {
        toast.success("Enquiry submitted successfully!");
        setEnquired(true);
      } else if (res?.status === false && res?.code === 409) {

        toast.info(res?.data?.message || "You have already enquired");
        setEnquired(true);
      } else {
        toast.error(res?.data?.message || "Something went wrong");
      }
    } catch (error) {

      toast.error(
        error?.response?.data?.message || error?.message || "Failed to submit enquiry"
      );
    }

    setEnquiredLoading(false);
  };

  const getImageUrl = (path) => {
    if (!path) return "/assets/images/no-image.png";

    // If already full URL → return as is
    if (path.startsWith("http")) return path;

    // Strip any leading "storage/" and build clean URL
    const cleanPath = path.replace(/^storage\//, "");
    const baseUrl = (process.env.REACT_APP_BASE_URL || "").replace(/\/api\/v2\/?$/, "").replace(/\/$/, "");

    return `${baseUrl}/storage/${cleanPath}`;
  };


  const isVideo = (url) => {
    if (typeof url !== 'string') return false;
    return url.match(/\.(mp4|webm|mkv|mov|avi)$/i);
  };

  const togglePlay = (e, img) => {
    e.stopPropagation();
    const v = videoRefs.current[img];
    if (v) {
      if (!v.paused) {
        v.pause();
        setIsPlayingMap(prev => ({ ...prev, [img]: false }));
      } else {
        v.play();
        setIsPlayingMap(prev => ({ ...prev, [img]: true }));
      }
    }
  };

  const togglePreviewPlay = (e, img) => {
    e.stopPropagation();
    const v = previewVideoRefs.current[img];
    if (v) {
      if (!v.paused) {
        v.pause();
        setIsPlayingMap(prev => ({ ...prev, [img]: false }));
      } else {
        v.play();
        setIsPlayingMap(prev => ({ ...prev, [img]: true }));
      }
      setPreviewOpen(prev => prev);
    }
  };
  return (
    <Container sx={{ py: 5 }}>
      <Box sx={{ mb: 3 }}>
        <BreadcrumbsNav />
      </Box>
      <Box
        sx={{
          backgroundImage: `url(/assets/images/plootbg.png)`,
          backgroundSize: "cover",
          backgroundRepeat: "no-repeat",
          backgroundPosition: "center",
          my: 5,
          p: { xs: 2, sm: 3, md: 2 },
          borderRadius: "16px",
          boxShadow: "0 4px 12px rgba(0,0,0,0.12)",
        }}>
        {/* FLEX WRAPPER */}
        <Box
          sx={{
            display: "flex",
            flexDirection: { xs: "column", lg: "row" },
            gap: { xs: 3, lg: 4 },
          }}
        >
          {/* LEFT BOX */}
          <Box
            sx={{
              bgcolor: "#fff",
              borderRadius: 4,
              p: { xs: 2, md: 2 },
              width: { xs: "100%", lg: "40%" },
              boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
            }}
          >
            <Box
              sx={{
                position: "relative",
                overflow: "hidden",

                "& .slick-dots": {
                  position: "absolute",
                  bottom: 10,
                  left: "50%",
                  transform: "translateX(-50%)",
                  margin: 0,
                  padding: "2px 6px",
                  borderRadius: "12px",
                  width: "auto",
                  display: "flex !important",
                  flexWrap: "nowrap",
                  justifyContent: "center",
                  alignItems: "center",
                  gap: "4px",
                  zIndex: 5,
                },

                "& .slick-dots li": {
                  margin: 0,
                  width: "auto",
                },

                "& .slick-dots li button": {
                  padding: 0,
                },

                "& .slick-dots li button:before": {
                  content: '""',
                },

                /* Custom dot */
                "& .slick-dots li": {
                  width: 8,
                  height: 8,
                  borderRadius: "50%",
                  backgroundColor: "rgba(255,255,255,0.6)",
                },

                "& .slick-dots li.slick-active": {
                  backgroundColor: "#fff",
                },
              }}>

              {data?.verify_status == 1 && <Box
                component="img"
                src="/assets/images/approved.png"
                alt="approved"
                sx={{
                  position: "absolute",
                  top: 0,
                  left: 0,
                  width: { xs: 80, md: 110 },
                  zIndex: 10,
                  transform: "translate(-22px, -22px) rotate(-15deg)",
                  pointerEvents: "none",
                }}
              />}
              {/* SHARE ICON */}
              <IconButton
                onClick={handleShare}
                sx={{
                  position: "absolute",
                  top: 10,
                  right: 10,
                  zIndex: 3,
                  background: "white",
                  "&:hover": { background: "#f5f5f5" },
                }}
              >
                <ShareIcon fontSize="small" />
              </IconButton>

              {/* WhatsApp Icon (next to share) */}
              <IconButton
                onClick={(e) => {
                  e.stopPropagation();
                  const shareUrl = window.location.href;
                  const shareText = `Check out this property: ${data?.property_name || "Property"}\n${shareUrl}`;
                  window.open(`https://api.whatsapp.com/send?text=${encodeURIComponent(shareText)}`, "_blank");
                }}
                sx={{
                  position: "absolute",
                  top: 10,
                  right: 50,
                  zIndex: 3,
                  background: "white",
                  "&:hover": { background: "#f5f5f5" },
                }}
              >
                <WhatsAppIcon sx={{ color: "#25D366" }} fontSize="small" />
              </IconButton>

              {/* YouTube Icon (straight bottom to share icon) */}
              {data?.youtube_link && (
                <IconButton
                  onClick={() => window.open(data.youtube_link, "_blank")}
                  sx={{
                    position: "absolute",
                    bottom: 10,
                    right: 10,
                    zIndex: 3,
                    background: "white",
                    "&:hover": { background: "#f5f5f5" },
                  }}
                >
                  <YouTubeIcon sx={{ color: "#FF0000" }} fontSize="small" />
                </IconButton>
              )}

              {/* LEFT ARROW */}
              {showArrows && (
                <IconButton
                  onClick={() => sliderRef.current?.slickPrev()}
                  sx={{
                    position: "absolute",
                    left: 8,
                    top: "50%",
                    transform: "translateY(-50%)",
                    zIndex: 2,
                    color: "#fff",
                    bgcolor: "transparent",
                    "&:hover": { bgcolor: "transparent" },
                  }}
                >
                  <ArrowBackIosNewIcon sx={{ fontSize: 26 }} />
                </IconButton>
              )}

              {loading ? (
                <Skeleton
                  variant="rectangular"
                  height={280}
                  sx={{ borderRadius: 3 }}
                  animation="wave"
                />
              ) : (
                <Slider ref={sliderRef} {...sliderSettings}>
                  {images.length > 0 ? (
                    images.map((img, i) => (
                      isVideo(img) ? (
                        <Box
                          onMouseEnter={() => setHoveredVideo(img)}
                          onMouseLeave={() => setHoveredVideo(null)}
                          sx={{ position: "relative", width: "100%", height: 310 }}
                        >
                          <video
                            ref={(el) => (videoRefs.current[img] = el)}
                            key={i}
                            src={img}
                            muted
                            loop
                            playsInline
                            disablePictureInPicture
                            disableRemotePlayback
                            controlsList="nopictureinpicture"
                            onContextMenu={(e) => e.preventDefault()}
                            onClick={(e) => togglePlay(e, img)}
                            style={{
                              height: 310,
                              width: "100%",
                              borderRadius: 12,
                              objectFit: "cover",
                              cursor: "pointer",
                            }}
                          />
                          {(hoveredVideo === img || !isPlayingMap[img]) && (
                            <IconButton
                              onClick={(e) => togglePlay(e, img)}
                              sx={{
                                position: "absolute",
                                top: "50%",
                                left: "50%",
                                transform: "translate(-50%, -50%)",
                                bgcolor: "rgba(0,0,0,0.5)",
                                color: "white",
                                borderRadius: "4px", // Rectangular
                                "&:hover": { bgcolor: "rgba(0,0,0,0.7)" },
                              }}
                            >
                              {isPlayingMap[img] ? <PauseIcon /> : <PlayArrowIcon />}
                            </IconButton>
                          )}
                        </Box>
                      ) : (
                        <CardMedia
                          key={i}
                          component="img"
                          image={img}
                          sx={{
                            height: 310, borderRadius: 3, objectFit: "cover", cursor: "pointer",
                          }}
                          onClick={() => {
                            setActiveIndex(i);
                            setPreviewOpen(true);
                          }}
                        />
                      )
                    ))
                  ) : (
                    <CardMedia
                      component="img"
                      image="/assets/images/no-image.png"
                      sx={{ height: 310, borderRadius: 3, }}
                    />
                  )}
                </Slider>
              )}
              {/* RIGHT ARROW */}
              {showArrows && (
                <IconButton
                  onClick={() => sliderRef.current?.slickNext()}
                  sx={{
                    position: "absolute",
                    right: 8,
                    top: "50%",
                    transform: "translateY(-50%)",
                    zIndex: 2,
                    color: "#fff",
                    bgcolor: "transparent",
                    "&:hover": { bgcolor: "transparent" },
                  }}
                >
                  <ArrowForwardIosIcon sx={{ fontSize: 26 }} />
                </IconButton>
              )}
            </Box>
          </Box>

          {/*RIGHT BOX ===== */}
          <Box
            sx={{
              borderRadius: 4,
              p: { xs: 2, md: 3 },
              width: { xs: "100%", lg: "100%" },
              display: "flex",
              flexDirection: "column",
              minHeight: "100%",
            }}
          >

            {/* <Box sx={{ flexGrow: 1 }}>
      
        <Grid container alignItems="center" mb={2}>
          <Grid item>
            <Typography variant="h6" fontWeight={500} sx={{ fontSize: "25px" }}>
              {data?.property_name}
            </Typography>

              <Typography
                   variant="body2"
                   color="text.secondary"
                   sx={{
                     fontSize: "15px",
                     whiteSpace: "normal",     
                     wordBreak: "break-word",
                     overflow: "visible",
                   }}
                 >
             {data?.location}
           </Typography>
           
          </Grid>

        
          <Grid
            item
            sx={{
              ml: "auto",
              display: "flex",
              justifyContent: "center",
            }}
          >
            <Button
              variant="contained"
              sx={{
                bgcolor: "#95B160",
                borderRadius: 2,
                textTransform: "none",
                mt: 1,
              }}
            >
              <ApartmentIcon sx={{ mr: 1 }} />
              {cate?.category_name || "Villa"}
            </Button>
          </Grid>
        </Grid>
      </Box> */}
            <Box sx={{ flexGrow: 1 }}>
              <Grid container alignItems="center" mb={2}>
                <Grid item>
                  {loading ? (
                    <>
                      <Skeleton width={220} height={35} />
                      <Skeleton width={180} height={20} />
                    </>
                  ) : (
                    <>
                      <Typography variant="h6" fontWeight={500} sx={{ fontSize: "25px" }}>
                        {data?.property_name}
                      </Typography>

                      <Typography
                        variant="body2"
                        color="text.secondary"
                        sx={{
                          fontSize: "15px",
                          whiteSpace: "normal",
                          wordBreak: "break-word",
                          overflow: "visible",
                        }}
                      >
                        {data?.location} {Number(data?.country) === 3 ? ", India" : Number(data?.country) === 2 ? ", Dubai" : ""}
                      </Typography>
                    </>
                  )}
                </Grid>

                <Grid
                  item
                  sx={{
                    ml: "auto",
                    display: "flex",
                    justifyContent: "center",
                  }}
                >
                  {loading ? (
                    <Skeleton variant="rounded" width={120} height={36} />
                  ) : (
                    <Box sx={{ display: "flex", gap: 1, flexWrap: "wrap", justifyContent: "center" }}>
                      <Button
                        variant="contained"
                        sx={{
                          bgcolor: "#95B160",
                          borderRadius: 2,
                          textTransform: "none",
                          mt: 1,
                        }}
                      >
                        <ApartmentIcon sx={{ mr: 1 }} />
                        {cate?.category_name || "Villa"}
                      </Button>
                      {data?.country && (
                        <Button
                          variant="outlined"
                          sx={{
                            color: "#95B160",
                            borderColor: "#95B160",
                            borderRadius: 2,
                            textTransform: "none",
                            mt: 1,
                            fontWeight: 600,
                            "&:hover": { borderColor: "#95B160", bgcolor: "rgba(149, 177, 96, 0.04)" }
                          }}
                        >
                          <LocationOnIcon sx={{ mr: 1 }} /> {Number(data.country) === 3 ? "India" : Number(data.country) === 2 ? "Dubai" : "Other country"}
                        </Button>
                      )}
                    </Box>
                  )}
                </Grid>
              </Grid>
            </Box>



            <Box sx={{ flexGrow: 4 }}>
              <Grid container spacing={6}>
                <Grid item xs={6}>
                  <InfoItem
                    title="Total Price"
                    icon="/assets/images/pricetag.png"
                    value={formatPrice(data?.price)}
                    loading={loading}
                  />
                </Grid>

                <Grid item xs={6}>
                  <InfoItem
                    title="Per Sq.ft"
                    icon="/assets/images/discount.png"
                    value={`₹${data?.area_sqft_price || "-"}`}
                    loading={loading}
                  />
                </Grid>

                <Grid item xs={6}>
                  <InfoItem
                    title="Plot Count"
                    icon="/assets/images/count.png"
                    value={data?.plot_count || "-"}
                    loading={loading}
                  />
                </Grid>

                <Grid item xs={6}>
                  <InfoItem
                    title="Total Sq.ft"
                    icon="/assets/images/area.png"
                    value={`${data?.area_sqft || "-"} Sq.ft`}
                    loading={loading}
                  />
                </Grid>
                {!loading && data?.verify_status === 1 && (
                  <Grid item xs={6}>
                    <InfoItem
                      title="Verification"
                      icon="/assets/images/verified.png"
                      value={data?.verify_status === 1 ? "Verified Plot" : "-"}
                      loading={loading}
                    />
                  </Grid>)}
                {/* {!loading && data?.country && (
                  <Grid item xs={6}>
                    <InfoItem
                      title="Country"
                      icon="/assets/images/placeholder_img.png" // Placeholder for location icon
                      value={Number(data?.country) === 3 ? "India" : Number(data?.country) === 2 ? "Dubai" : "-"}
                      loading={loading}
                    />
                  </Grid>)} */}
              </Grid>


              {/* <Grid container spacing={6}>
    <Grid item xs={6}>
      <InfoItem
        title="Per Sq.ft"
        icon="/assets/images/discount.png"
        value={`₹${data?.area_sqft_price || "-"}`}
      />
    </Grid>

    <Grid item xs={6}>
      <InfoItem
        title="Total Sq.ft"
        icon="/assets/images/area.png"
        value={`${data?.area_sqft || "-"} Sq.ft`}
      />
    </Grid>
  </Grid> */}
            </Box>


            <Box display="flex" justifyContent="center" mt={1}>
              <Button
                variant="contained"
                sx={{
                  background: "#7E9F40",
                  borderRadius: 20,

                  px: { xs: 2.5, sm: 3.5 },
                  py: 0.8,

                  minWidth: "auto",
                  width: "fit-content",
                  textTransform: "capitalize",
                  fontSize: { xs: 14, sm: 14 },
                  fontWeight: 500,

                  display: "flex",
                  alignItems: "center",
                  gap: 1,
                  color: "#fff",
                  "&:hover": { background: "#7E9F40" },
                }}
                disabled={enquired || data?.sold_status === 1}
                onClick={() => requireLogin(() => setConfirmOpen(true))}
              >
                <CallIcon sx={{ fontSize: 18 }} />

                {enquiredloading ? (
                  <CircularProgress color="inherit" size={18} />
                ) : data?.sold_status === 1 ? (
                  "Sold Out"
                ) : enquired ? (
                  "Enquired"
                ) : (
                  "Send Enquiry"
                )}
              </Button>

              {/* CONFIRM POPUP */}
              <Dialog
                open={confirmOpen}
                onClose={() => setConfirmOpen(false)}
                maxWidth="xs"
                fullWidth
              >
                <DialogTitle>Confirm Enquiry</DialogTitle>

                <DialogContent>
                  <Typography>
                    Are you sure you want to send this enquiry?
                  </Typography>
                </DialogContent>

                <DialogActions>
                  <Button variant="outlined" onClick={() => setConfirmOpen(false)}>
                    No
                  </Button>

                  <Button
                    variant="contained"
                    sx={{ bgcolor: "#6BAF4B" }}
                    onClick={() => {
                      setConfirmOpen(false);
                      handleResidentialQuery();
                    }}
                  >
                    Yes
                  </Button>
                </DialogActions>
              </Dialog>
            </Box>
          </Box>
        </Box>
      </Box>

      {/*SPECIFICATION*/}
      <Box
        sx={{
          display: "flex",
          flexDirection: { xs: "column", lg: "row" },
          gap: { xs: 3, lg: 4 },
          mt: 4,
        }}
      >
        <Box
          sx={{
            width: "100%",
            display: "flex",
            flexDirection: "column",
          }}
        >
          <Typography fontWeight={600} mb={2} color="#608900">
            FACILITIES:
          </Typography>

          {/* WRAPPER */}
          <Box
            sx={{
              display: "grid",
              gridTemplateColumns: {
                xs: "1fr",
                sm: "repeat(2, 1fr)",
                md: "repeat(3, 1fr)",
                lg: "repeat(4, 1fr)",
              },
              gap: 1.5,
              p: 1.5,
              borderRadius: 1.5,
              border: "1px solid #95B160",
              backgroundColor: "#FBFBF8",
            }}
          >
            {validFacilities.length > 0 ? (
              validFacilities.map((fac, idx) => (
                <Box
                  key={idx}
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    gap: 1.5,
                    p: 1.5,
                    borderRadius: 1.5,
                    border: "1px solid #95B160",
                    backgroundColor: "#FBFBF8",
                    cursor: "pointer",
                    transition: "all 0.25s ease",
                    minWidth: 0,
                    "&:hover": {
                      transform: "translateY(-2px)",
                      boxShadow: "0 4px 10px rgba(0,0,0,0.15)",
                    },
                  }}
                >
                  {/* ICON */}
                  {fac.images ? (
                    <img
                      src={fac.images}
                      width={22}
                      height={22}
                      alt={fac.name}
                    />
                  ) : (
                    <HomeIcon fontSize="small" />
                  )}

                  {/* TEXT */}
                  <Box minWidth={0}>
                    <Typography
                      fontWeight={600}
                      fontSize={{ xs: 12, sm: 13, md: 14 }}
                      noWrap
                    >
                      {fac.name}
                    </Typography>

                    <Typography
                      fontSize={{ xs: 11, sm: 12 }}
                      color="#666"
                      noWrap
                    >
                      {fac.value}
                    </Typography>
                  </Box>
                </Box>
              ))
            ) : (
              <Box
                sx={{
                  gridColumn: "1 / -1",
                  py: 4,
                  textAlign: "center",
                  border: "1px dashed #ccc",
                  borderRadius: 2,
                  color: "#888",
                }}
              >
                <HomeIcon color="disabled" />
                <Typography fontSize={13} mt={1}>
                  No Facilities Found
                </Typography>
              </Box>
            )}
          </Box>
        </Box>

      </Box>



      {/* ── BLUEPRINT + 3D IMAGE ── */}
      {/* ── BLUEPRINT + 3D IMAGE ── */}
      <Box
        sx={{
          display: "flex",
          flexDirection: "row",      // ← always row, never column
          flexWrap: "nowrap",        // ← never wrap/break to next line
          gap: { xs: 1.5, md: 4 },
          mt: 6,
          width: "100%",
        }}
      >
        {/* BLUEPRINT */}
        <Box sx={{ flex: 1, minWidth: 0, height: { xs: 180, sm: 260, md: 420 } }}>
          <ResdentialImageView
            image={getImageUrl(data?.blueprint)}
            viewerId="residential-blueprint-viewer"
            variant="blueprint"
            title="GreenHeap Plots Layout Sketch"
          />
        </Box>

        <Box sx={{ flex: 1, minWidth: 0, height: { xs: 180, sm: 260, md: 420 } }}>
          <ResdentialImageView
            image={getImageUrl(data?.three_d_image)}
            viewerId="residential-3d-viewer"
            variant="blueprint"
            title="Aerial View"
          />
        </Box>
      </Box>

      {/* ── LOCATION / MAP ── */}
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          mt: 4,
        }}
      >
        <Typography fontWeight={600} mb={2} color="#608900">
          LOCATION:
        </Typography>
        <Box
          sx={{
            height: { xs: 320, sm: 380, md: 420 },
            borderRadius: 3,
            overflow: "hidden",
            border: "1px solid #e0e0e0",
            bgcolor: "#f5f5f5",
          }}
        >
          {loading ? (
            <Skeleton
              variant="rectangular"
              width="100%"
              height="100%"
              animation="wave"
            />
          ) : (
            <PlotMap
              lat={lat}
              lng={lng}
              map_set={data?.map_set}
              propertyName={data?.property_name}
              showRadius={["Plot", "Land", "Villa", "Flat", "Apartment", "Individual House", "Independent House", "Town house"].includes(data?.cate?.category_name)}
            />
          )}
        </Box>
      </Box>


      {data?.about_property?.trim() && (
        <Box sx={{ mt: 5 }}>
          <ResidentialDescription
            area={data?.area}
            per_sq={data?.unit_spilt}
            price={data?.price}
            totalPrice={data?.total_price}
            description={data?.about_property}
          />
        </Box>
      )}



      <Box sx={{ mt: 5 }}>
        {/* <PlotDocumentSection documentVerified={true} documents={documents} /> */}
        {/* <ResidentialDocument documentVerified={data?.document_verified}documents={documents}/> */}
      </Box>
      <Box sx={{ my: 4 }}>
        <ResidentialLocation
          address={data?.location}
          uldNumber={data?.id}
          amenity={data?.amenitiesall}
          nearbyLocations={data?.nearbyLocations}
          country={data?.country}

        />
      </Box>



      <Box>
        <Dialog
          open={previewOpen}
          onClose={() => setPreviewOpen(false)}
          maxWidth="lg"
          fullWidth
          PaperProps={{
            sx: {
              borderRadius: 2,
              overflow: "hidden",
              bgcolor: "rgba(0,0,0,0.5)",
            },
          }}
        >
          {/* CLOSE BUTTON (TOP RIGHT) */}
          <IconButton
            onClick={() => setPreviewOpen(false)}
            sx={{
              position: "absolute",
              top: { xs: 10, sm: 16 },
              right: { xs: 10, sm: 20 },
              zIndex: 10,
              color: "#fff",
            }}
          >
            <CloseIcon />
          </IconButton>

          <DialogContent sx={{ p: 0 }}>
            <Box
              sx={{
                position: "relative",
                height: { xs: 320, sm: 500, md: 600 },
                bgcolor: "transparent",
                overflow: "hidden"
              }}
            >
              {/* LEFT ARROW */}
              {showPreviewArrows && (
                <IconButton
                  onClick={() => previewSliderRef.current?.slickPrev()}
                  sx={{
                    position: "absolute",
                    left: 12,
                    top: "50%",
                    transform: "translateY(-50%)",
                    zIndex: 3,
                    color: "#fff",
                    bgcolor: "rgba(0,0,0,0.5)",

                    "&:hover": { bgcolor: "rgba(0,0,0,0.7)" },
                  }}
                >
                  <ArrowBackIosNewIcon />
                </IconButton>
              )}
              {/* SLIDER */}
              <Slider
                ref={previewSliderRef}
                initialSlide={activeIndex}
                dots
                infinite
                speed={400}
                slidesToShow={1}
                slidesToScroll={1}
                arrows={false}
              >
                {images.map((img, i) => (
                  <Box key={i}>
                    <Box
                      sx={{
                        height: { xs: 320, sm: 500, md: 600 },
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        bgcolor: "rgba(0,0,0,0.5)",
                        p: 1,
                      }}
                    >
                      {isVideo(img) ? (
                        <Box
                          onMouseEnter={() => setHoveredVideo(img)}
                          onMouseLeave={() => setHoveredVideo(null)}
                          sx={{ position: "relative", width: "100%", height: "100%" }}
                        >
                          <video
                            ref={(el) => (previewVideoRefs.current[img] = el)}
                            src={img}
                            loop
                            muted
                            playsInline
                            disablePictureInPicture
                            disableRemotePlayback
                            controlsList="nopictureinpicture"
                            onContextMenu={(e) => e.preventDefault()}
                            onClick={(e) => togglePreviewPlay(e, img)}
                            style={{
                              width: "100%",
                              height: "100%",
                              objectFit: "contain",
                            }}
                          />
                          {(hoveredVideo === img || previewVideoRefs.current[img]?.paused) && (
                            <IconButton
                              onClick={(e) => togglePreviewPlay(e, img)}
                              sx={{
                                position: "absolute",
                                top: "50%",
                                left: "50%",
                                transform: "translate(-50%, -50%)",
                                bgcolor: "rgba(0,0,0,0.5)",
                                color: "white",
                                borderRadius: "4px", // Rectangular
                                "&:hover": { bgcolor: "rgba(0,0,0,0.7)" },
                              }}
                            >
                              {previewVideoRefs.current[img]?.paused ? <PlayArrowIcon /> : <PauseIcon />}
                            </IconButton>
                          )}
                        </Box>
                      ) : (
                        <img
                          src={img}
                          alt=""
                          style={{
                            width: "100%",
                            height: "100%",
                            objectFit: "contain",
                          }}
                        />
                      )}
                    </Box>
                  </Box>
                ))}
              </Slider>

              {/* RIGHT ARROW */}
              {showPreviewArrows && (
                <IconButton
                  onClick={() => previewSliderRef.current?.slickNext()}
                  sx={{
                    position: "absolute",
                    right: 12,
                    top: "50%",
                    transform: "translateY(-50%)",
                    zIndex: 3,
                    color: "#fff",
                    bgcolor: "rgba(0,0,0,0.5)",
                    "&:hover": { bgcolor: "rgba(0,0,0,0.7)" },
                  }}
                >
                  <ArrowForwardIosIcon />
                </IconButton>
              )}
            </Box>
          </DialogContent>
        </Dialog>
      </Box>
    </Container>
  );
}

function InfoItem({ icon, title, value, loading }) {
  return (
    <Box sx={{ display: "flex", alignItems: "flex-start" }}>

      {/* ICON */}
      <Box sx={{ minWidth: 30 }}>
        {loading ? (
          <Skeleton variant="circular" width={30} height={30} />
        ) : (
          <img src={icon} width={26} alt="" />
        )}
      </Box>
      {/* TEXT */}
      <Box>
        {loading ? (
          <>
            <Skeleton width={80} height={18} />
            <Skeleton width={120} height={18} />
          </>
        ) : (
          <>
            <Typography fontSize={13} fontWeight={600} color="#95B160">
              {title}
            </Typography>

            <Typography fontSize={14} fontWeight={500}>
              {value || "-"}
            </Typography>
          </>
        )}
      </Box>
    </Box>
  );
}



